// src/modules/undoRedo/commands/StateSnapshotCommand.js
//
// Genel "durum anlık görüntüsü" komutu — bir nesne kümesinin pozisyon ve/veya çizgi
// geometrisi durumunu before/after olarak saklar; undo/redo'da geri yükler.
// Panel M-sürükleme (panel pos + bağlı wire geometrileri + trafo/title pos) ve
// wireMarker sürükleme (marker çizgi geometrileri) için kullanılır.

import * as THREE from 'three';
import BaseCommand from './BaseCommand';

class StateSnapshotCommand extends BaseCommand {
  /**
   * @param {Array} beforeEntries - capture() çıktısı (sürükleme öncesi)
   * @param {Array} afterEntries  - capture() çıktısı (sürükleme sonrası)
   * @param {string} label
   */
  constructor(beforeEntries, afterEntries, label = 'STATE_SNAPSHOT') {
    super(label, { before: beforeEntries, after: afterEntries });
    this.beforeEntries = beforeEntries || [];
    this.afterEntries = afterEntries || [];
  }

  /**
   * Nesnelerin mevcut durumunu yakala. Line (geometri) → 'lineGeometry',
   * diğer (group/mesh) → 'position'.
   * @param {Array<THREE.Object3D>} objects
   * @returns {Array<{uuid,kind,value}>}
   */
  static capture(objects) {
    const entries = [];
    for (const o of objects) {
      if (!o) continue;
      if (o.isLine && o.geometry?.attributes?.position) {
        const pos = o.geometry.attributes.position;
        const pts = [];
        for (let i = 0; i < pos.count; i++) pts.push({ x: pos.getX(i), y: pos.getY(i), z: pos.getZ(i) });
        entries.push({ uuid: o.uuid, kind: 'lineGeometry', value: pts });
      } else {
        entries.push({ uuid: o.uuid, kind: 'position', value: { x: o.position.x, y: o.position.y, z: o.position.z } });
      }
    }
    return entries;
  }

  /** before/after farklı mı (değişmediyse komut oluşturma). */
  static changed(beforeEntries, afterEntries) {
    return JSON.stringify(beforeEntries) !== JSON.stringify(afterEntries);
  }

  _apply(scene, entries) {
    if (!scene || !entries?.length) return;
    const map = new Map();
    scene.traverse((o) => map.set(o.uuid, o));
    for (const e of entries) {
      const o = map.get(e.uuid);
      if (!o) continue;
      if (e.kind === 'lineGeometry' && o.geometry) {
        o.geometry.setFromPoints(e.value.map((p) => new THREE.Vector3(p.x, p.y, p.z ?? 0)));
        if (o.geometry.attributes?.position) o.geometry.attributes.position.needsUpdate = true;
        o.geometry.computeBoundingSphere?.();
      } else if (e.kind === 'position') {
        o.position.set(e.value.x, e.value.y, e.value.z ?? 0);
        // Panel basePoint'i pozisyonla senkron tut (varsa)
        if (o.userData?.basePoint) {
          o.userData.basePoint = { ...o.userData.basePoint, x: e.value.x, y: e.value.y };
        }
        o.updateMatrixWorld?.(true);
      }
    }
  }

  execute(scene) { this._apply(scene, this.afterEntries); } // redo
  undo(scene) { this._apply(scene, this.beforeEntries); }
}

export default StateSnapshotCommand;
